
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State } from '../reducers/advisors.reducers';

export const selectDataState = createFeatureSelector<State>('advisorData');

export const selectAdvisorData = createSelector(selectDataState, (state) => state.advisorData);
export const selectAdvisorLoading = createSelector(selectDataState, (state) => state.loading);
export const selectAdvisorError = createSelector(selectDataState, (state) => state.error);
